import React from 'react';

import {useCurrentUserState} from 'app/current-user/api';
import {ShowNonFieldFormErrors} from 'app/general/forms';
import {SweetLoadingBar} from 'app/general/sweet-loading-bar/SweetLoadingBar';

import {DueDateForm} from './DueDateForm';
import {RRuleForm} from './RRuleForm';
import {TaskDescriptionField} from './TaskDescriptionField';

import type {WizardFormPaneProps} from 'app/general/widgets/WizardAccordion';
import type {WriteTaskTemplateSerializedType} from 'sweet-types';

interface Props extends WizardFormPaneProps<void> {
  isAssigning: boolean;
  task: Partial<WriteTaskTemplateSerializedType>;
  lockDueDate: boolean;
  prependToDueDateForm?: React.ReactNode;
  appendToDueDateForm?: React.ReactNode;
  actionButtonText: [string, string];
  updateTask: (updates: Partial<WriteTaskTemplateSerializedType>) => unknown;
}

export function DueDateRecurringForm({
  task,
  updateTask,
  isAssigning,
  lockDueDate,
  prependToDueDateForm,
  appendToDueDateForm,
  actionButtonText,
  FooterComponent,
}: Props): JSX.Element {
  const {timezone, language} = useCurrentUserState().data!;

  return (
    <>
      <div className="pb-4">
        <TaskDescriptionField
          description={task.description!}
          onChange={(description) => updateTask({description})}
        />
      </div>

      <div className="pb-4">
        <DueDateForm
          due={task.due!}
          onDueChange={(due) => updateTask({due})}
          dtstart={task.dtstart}
          onDtstartChange={(dtstart) => updateTask({dtstart})}
          force_dtstart={task.force_dtstart}
          onForceDtstartChange={(force_dtstart) => updateTask({force_dtstart})}
          prependToDueDateForm={prependToDueDateForm}
          lockDueDate={lockDueDate}
          userTimezone={timezone}
          userLanguage={language}
        />
      </div>

      {appendToDueDateForm}

      <RRuleForm
        dtstart={task.due!}
        rrule={task.rrule!}
        onChange={(rrule) => updateTask({rrule})}
      />
      <ShowNonFieldFormErrors />

      <SweetLoadingBar loading={isAssigning ? 1 : 0} />

      <FooterComponent
        isCompleted={!isAssigning}
        result={undefined}
        text={isAssigning ? actionButtonText[1] : actionButtonText[0]}
      />
    </>
  );
}
